import styled from 'styled-components';

import DefaultPopup from '@r1-frontend/ui-react/components/popups/defaultPopup';

export const BREAKPOINT = '@media (max-width: 640px)';

export const Popup = styled(DefaultPopup)`
  ${BREAKPOINT} {
    top: 100px;
  }
`;
